import React from 'react';

import { PageHeader } from 'antd';
import { useHistory } from 'react-router-dom';
import { T } from 'react-translator-component';
import styled from 'styled-components';

import PushNotificationConfigForm from '../organisms/PushNotificationConfigForm';
import PushLimitConfigForm from '../organisms/PushLimitConfigForm';
import { isAdvancedPushNotificationUser } from '../../utils/isAdvancedPushNotificationUser/isAdvancedPushNotificationUser';

const PushNotificationPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;

  h1 {
    font-size: 24px;
  }
`;

const PushNotificationPage = () => {
  const history = useHistory();
  const advancedPush = isAdvancedPushNotificationUser();
  const initialValues = {
    subject: '',
    message: '',
    sendMode: 'NOW',
    scheduleDate: null,
    scheduleTime: null,
    recurrence: 'NONE',
    recurrenceUntil: null,
  };

  return (
    <PushNotificationPageWrapper>
      <PageHeader
        className='site-page-header'
        onBack={() => history.goBack()}
        title={T('Enviar Push Notification para o celular dos usuários')}
      />
      <PushNotificationConfigForm initialValues={initialValues} allowScheduling />
      {advancedPush && <PushLimitConfigForm />}
    </PushNotificationPageWrapper>
  );
};

export default PushNotificationPage;
